export default __webpack_public_path__ + "static/media/arrow_4.0120dc18.svg";